import $ from "jquery";

(function () {

  $(document).ready(function() {

    //Switcher
    const switcher = () => {
      //style reset
      $(".btn_month, .for_month, .title_month").css("display", "none");
      //listener
      $(".switch").on("click", function() {
        if ($(this).find('input').attr("checked")) {
          $(this).find('input').attr("checked", false);
          $(this).find('.swSlider').css("-webkit-transform", "translateX(-19px)");
          $(this).prev().css("color", "#4f4f4f");
          $(this).next().css("color", "#ababab");
          $('.annual_discount').hide();
          $(".for_year").hide();
          $(".for_month").show();
          $(".btn_year").css("display", "none");
          $(".btn_month").css("display", "flex");
          $(".title_month").css("display", "block");
          $(".title_year").css("display", "none");
          $("#js_cnPricingExc").hide();
          $(".pricing .row").css('max-width', '800px');
        } else {
          $(this).find('input').attr("checked", true);
          $(this).find('.swSlider').css("-webkit-transform", "translateX(0px)");
          $(this).next().css("color", "#4f4f4f");
          $(this).prev().css("color", "#ababab");
          $('.annual_discount').show();
          $(".for_year").show();
          $(".for_month").hide();
          $(".btn_month, .title_month").css("display", "none");
          $(".btn_year").css("display", "flex");
          $(".title_year").css("display", "block");
          $("#js_cnPricingExc").show();
          $(".pricing .row").css('max-width', '100%');
        }
      });
    }

    if (window.location.pathname.includes('cn/pricing')) {
      switcher();
      log('switch');
    }

    if (window.location.pathname.includes('pricing')) {
      $(".color-link").parent().hide();
      $("li.scroll").eq(1).children().css("border-bottom", "none");
    }

  });
}());
